<template>
  <nb-confirm ghost text="reset" v-on="$listeners" />
</template>

<script>
export default {
  name: 'NbReset',
};
</script>
